import { useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'

import type { Gebied } from '@models/Gebied'

import { SelectObject } from '../../../core/components/SelectObject'
import { StyledError } from '../../../theme/components/StyledError'
import { useCreateGebiedswissel } from '../../hooks/useCreateGebiedswissel'

interface Props {
  onClose: () => void
  gebieden: Gebied[]
}

export const CreateGebiedswissel = ({ onClose, gebieden }: Props) => {
  const [gebied, setGebied] = useState<any>(null)
  const [omschrijving, setOmschrijving] = useState('')
  const [text, setText] = useState('')
  const [errors, setErrors] = useState({ gebiedError: false, textError: false })
  const { mutate: createGebiedswissel, error } = useCreateGebiedswissel()

  const handleClickCreate = () => {
    if (!gebied || !text) {
      setErrors({
        gebiedError: !gebied,
        textError: !text,
      })
    } else {
      createGebiedswissel(
        {
          gebiedscode: gebied.code,
          lines: text.split('\n'),
          omschrijving,
        },
        { onSuccess: () => onClose() },
      )
    }
  }

  return (
    <Dialog open fullWidth>
      <DialogTitle>Wijzigen gebied voor projecten</DialogTitle>
      <DialogContent>
        <StyledError error={error} />
        <Box
          sx={{ width: '95%', marginLeft: 'auto', marginRight: 'auto', p: 1 }}
        >
          <FormControl sx={{ width: '100%', p: 1 }}>
            <TextField
              variant="standard"
              id="omschrijving"
              label="Omschrijving"
              value={omschrijving}
              onChange={(e) => setOmschrijving(e.target.value)}
              error={errors['omschrijvingError']}
            />
          </FormControl>
          <FormControl sx={{ width: '100%', p: 1 }}>
            <SelectObject
              options={gebieden}
              value={gebied}
              onChange={setGebied}
              getOptionLabel={(gebied) => `${gebied.code} - ${gebied.label}`}
              label="Doel gebied"
              error={errors['gebiedError']}
            />
          </FormControl>
          <FormControl sx={{ mt: 3, width: '100%' }}>
            <TextField
              value={text}
              multiline
              rows={6}
              label="Lijst van project ids (met optioneel datum)"
              onChange={(e) => setText(e.target.value)}
              required
              error={errors['textError']}
            />
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button onClick={handleClickCreate} color="primary">
          Aanmaken
        </Button>
      </DialogActions>
    </Dialog>
  )
}
